import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  const dashLink = user?.role === 'tutor'  ? '/tutor/dashboard'
                 : user?.role === 'parent' ? '/parent/dashboard'
                 : user?.role === 'admin'  ? '/admin/dashboard' : null;

  return (
    <nav style={{
      background:'#fff', borderBottom:'1.5px solid #deeee7',
      position:'sticky', top:0, zIndex:200
    }}>
      <div className="container" style={{display:'flex',alignItems:'center',height:68,gap:32}}>
        {/* Logo */}
        <Link to="/" style={{display:'flex',alignItems:'center',gap:10,textDecoration:'none',flexShrink:0}}>
          <div style={{width:34,height:34,borderRadius:9,background:'linear-gradient(135deg,#22c97f,#0d6e4f)',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
            </svg>
          </div>
          <span style={{fontWeight:800,fontSize:'1.05rem',color:'#052e1c'}}>Budget<span style={{color:'#22c97f'}}>Tutor</span></span>
        </Link>

        {/* Nav links */}
        <div style={{display:'flex',gap:4,flex:1}} className="nav-links-desktop">
          {[['Find a Tutor','/find-tutors'],['How It Works','/how-it-works'],['Become a Tutor','/become-a-tutor']].map(([label,path])=>(
            <Link key={path} to={path} style={{
              padding:'8px 14px', borderRadius:8, fontWeight:600, fontSize:'0.875rem',
              color: loc.pathname===path ? '#0d6e4f' : '#3d6650',
              background: loc.pathname===path ? '#edfaf3' : 'transparent',
              textDecoration:'none', transition:'all 0.2s'
            }}>{label}</Link>
          ))}
        </div>

        {/* Auth buttons */}
        <div style={{display:'flex',gap:10,alignItems:'center',flexShrink:0}}>
          {user ? (
            <>
              <Link to={dashLink} className="btn btn-secondary btn-sm">Dashboard</Link>
              <button onClick={logout} className="btn btn-ghost btn-sm">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-ghost btn-sm">Sign in</Link>
              <Link to="/register/parent" className="btn btn-primary btn-sm">Get started</Link>
            </>
          )}
        </div>
      </div>

      <style>{`
        @media(max-width:768px){.nav-links-desktop{display:none}}
      `}</style>
    </nav>
  );
}
